---
en:
  errors:
    messages:
      after: must be after %{restriction}
      before: must be before %{restriction}
      invalid_date: is not a valid date
      invalid_datetime: is not a valid datetime
      invalid_time: is not a valid time
      is_at: must be at %{restriction}
      on_or_after: must be on or after %{restriction}
      on_or_before: must be on or before %{restriction}
